// Registration Fields
export const FIELDS = {
  COUNTRY: 'country',
  HONOR_CODE: 'honor_code',
  TERMS_OF_SERVICE: 'terms_of_service',
};

// Registration Error Codes
export const FORBIDDEN_REQUEST = 'forbidden-request';
export const FORM_SUBMISSION_ERROR = 'form-submission-error';
export const INTERNAL_SERVER_ERROR = 'internal-server-error';
export const TPA_AUTHENTICATION_FAILURE = 'tpa-authentication-failure';
export const TPA_SESSION_EXPIRED = 'tpa-session-expired';

// export const ADDITIONAL_INFORMATION_OPTION_BOX_TYPE;
export const ADDITIONAL_INFORMATION_OPTION_BOX_TYPE = 'option-box';
export const ADDITIONAL_INFORMATION_YEAR_OF_BIRTH_TYPE = 'year-input';
export const ADDITIONAL_INFORMATION_CITY_COUNTRY_TYPE = 'city-country';

export const REGISTRATION_CONFIRMATION_STEP_NUMBER = 3;

export  const SCHOOL_IDS = ['el', 'jhs', 'hs'];
export  const ACADEMIC_IDS = ['b', 'm', 'p'];
export  const ALL_ACADEMIC_EDUCATION  = 'ae'; // helpers to identify academic background option

// * level_of_education: One of the following values:
// * "p": PhD or Doctorate
// * "m": Master's or professional degree
// * "b": Bachelor's degree
// * "a": Associate's degree
// * "hs": Secondary/high school
// * "jhs": Junior secondary/junior high/middle school
// * "el": Elementary/primary school
// * "none": None
// * "o": Other

// *new*: "hs": school education (merged from hs, jhs, el)

